/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    shape, string, number,
    bool, arrayOf, func, oneOfType,
} from 'prop-types';
import { connect, useDispatch } from 'react-redux';

import Button from '@material-ui/core/Button';
import Image from '../../../../common/Image';
import EventDispatcher from '../../../../state/reducers/EventDispatcher';
import { decode as htmlDecode } from '../../../../utils/htmlEntity';
import configENV from '../../../../config';
import { isEmpty } from '../../../../utils/object';
import { trackEvent } from '../../../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';

const { PERSIST_KEY } = configENV;

const ProductAddedToCart = ({
    recipient, handleGiftListChooseSomethingDifferent, isReadyState, isGiftListV2,
}) => {
    if (isEmpty(recipient.cartDetail)) return null;
    const dispatch = useDispatch();
    const product = recipient.cartDetail;
    const newName = htmlDecode(product.productDetail.name);
    const chooseSomethingDifferentLabel = isReadyState
        ? 'Undo'
        : 'Removing item from cart...';
    const imageURL = product.productDetail.image
        ? product.productDetail.image.replace(/^http[s]?:/, 'https:')
        : '';
    return (
        <>
            <div className="bold margin-bottom">You Have Selected:</div>
            <div className="split">
                <div>
                    <Image className="flex-none" src={imageURL} style={{ width: '100%' }} alt={newName} />
                </div>
                <div className="flex-2">
                    <span className="bold">
                        {newName} ({!isGiftListV2 && product.productDetail.sku})
                    </span>
                    <span>
                        {' '}
                        is currently in your cart for {recipient.firstname}{' '}
                        {recipient.lastname}.
                    </span>
                </div>
            </div>
            {!isGiftListV2 &&  (
                <div className="align-center margin-top-2x margin-bottom-2x">
                    <Button
                        className="buttonHDSecondary choose-something-different-button"
                        onClick={() => {
                            handleGiftListChooseSomethingDifferent(recipient);
                            dispatch(trackEvent({
                                eventCategory: 'Gift List V1',
                                eventAction: 'Item Removed',
                                eventLabel: product?.productDetail?.sku || '',

                                ga_event_name: 'gift_list_interaction',
                                interaction_type: 'remove_item',
                            }));
                        }}
                    >
                        {chooseSomethingDifferentLabel}
                    </Button>
                </div>
            )}
        </>
    );
};

ProductAddedToCart.defaultProps = {
    recipient: {},
    handleGiftListChooseSomethingDifferent: '',
    isGiftListV2: false,
};

ProductAddedToCart.propTypes = {
    recipient: shape({
        AddressBookEntryId: string,
        addToCart: string,
        address: shape({
            addressId: string,
            apt: string,
            city: string,
            company: string,
            country: shape({
                id: string,
                name: string,
            }),
            location: shape({
                id: number,
                name: string,
            }),
            state: shape({
                id: string,
                name: string,
            }),
            street: string,
            zipcode: string,
        }),
        addressId: string,
        firstname: string,
        giftArrived: string,
        id: string,
        isNewRecipient: bool,
        lastname: string,
        occasionId: string,
        orderItemId: string,
        products: arrayOf(
            shape({
                content: string,
                crossedPrice: oneOfType([number, string]),
                discountPrice: oneOfType([number, string]),
                id: string,
                image: string,
                name: string,
                parentCatalogEntryId: string,
                partNumber: string,
                price: number,
                seoproductDisplayURL: string,
                sku: string,
                status: string,
            }),
        ),
        type: string,
    }),
    isReadyState: bool.isRequired,
    handleGiftListChooseSomethingDifferent: func,
    isGiftListV2: bool,
};

const mapStateToProps = (state) => {
    /* istanbul ignore next */
    const newState = state[PERSIST_KEY] ? state[PERSIST_KEY] : state;
    // console.log('ProductAddedToCart - newState', newState);
    return {
        isReadyState: newState.isReadyState,
        // recipient: newState.modal.content,
        addToCart:
            typeof newState.modal.content === 'object'
                ? newState.modal.content.addToCart
                : '',
    };
};

const mapDispatchToProps = (dispatch) => ({
    handleGiftListChooseSomethingDifferent: (recipient) => dispatch(EventDispatcher.handleGiftListChooseSomethingDifferent(recipient)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(ProductAddedToCart);
